import HookUseDelayToNextFrame from './fake-component.js'

const useDelayToNextFrame = () => {
  return arg => {
    if (!arg) return

    const isFunc = target => typeof target === 'function'

    return requestAnimationFrame(() => {
      setTimeout(() => {
        if (isFunc(arg)) {
          return arg()
        } else if (Array.isArray(arg)) {
          arg.forEach(callback => isFunc(callback) && callback())
        }
      }, 0)
    })
  }
}

export {useDelayToNextFrame}
export default HookUseDelayToNextFrame
